const stars = (filled, color, width = 20, total = 3) => {
  const columns = [];

  for (let i = 0; i < filled; i++) {
    columns.push({
      width: "auto",
      stack: [
        {
          width,
          svg: `
<svg viewBox="0 0 24 24">
    <path
      fill="${color}"
      d="M12 17.27 18.18 21l-1.64-7.03L22 9.24l-7.19-.62L12 2 9.19 8.62 2 9.24l5.45 4.73L5.82 21 12 17.27Z"
    />
</svg>
`,
        },
      ],
    });
  }

  for (let i = 0; i < total - filled; i++) {
    columns.push({
      width: "auto",
      stack: [
        {
          width,
          svg: `
<svg viewBox="0 0 24 24">
  <path
    fill="${color}"
    d="m12 15.39-3.76 2.27.99-4.28-3.32-2.88 4.38-.37L12 6.09l1.71 4.04 4.38.37-3.32 2.88.99 4.28M22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.45 4.73L5.82 21 12 17.27 18.18 21l-1.64-7.03L22 9.24Z"
  />
</svg>
`,
        },
      ],
    });
  }

  return {
    columns,
  };
};

export default stars;
